import moment from 'utils/moment';
import { daysBetween } from 'TimeOffList/services/format';

export const MAX_CLOSURE_DAYS = 13;

/**
 * Client-side mirror of the backend closure rules. Returns an error message, or
 * null when the range can be saved. Start may be in the past (an ongoing
 * closure can be edited); only a fully elapsed range is rejected.
 */
export const validateClosure = (start: string, end: string, reason: string): string | null => {
  if (!reason.trim()) return 'Reason is required';
  if (!start || !end) return 'Please select a date';
  if (end < start) return 'End date must not be before start date';
  if (end < moment().format('YYYY-MM-DD')) return 'End date must not be in the past';
  if (daysBetween(start, end) > MAX_CLOSURE_DAYS) return 'A closure must be shorter than 2 weeks';
  return null;
};
